
import './CopTable.scss';

import { GridColDef } from '@mui/x-data-grid'

export type RoleDescriptionTitles = {
  role?: string
  description?: string
}

export function roleDescriptionColumn(
  columnTitles: RoleDescriptionTitles = {},
): GridColDef[] {
  return  [
    {
      field: 'name',
      headerName: columnTitles.role ?? 'Role',
      flex: 1,
      minWidth: 180,
      filterable:true,
    },
    {
      field: 'description',
      headerName: columnTitles.description ?? 'Description',
      flex: 0.8,
      minWidth: 130,
      filterable:true,
    },
  ]
}
